import React from 'react';
import { Box } from '@mui/material';
import { NomsDeDomaineWidget, NomsDeDomaineWidgetType } from '../../molecules';

export type NomsDeDomaineListProps = {
    items?: Array<NomsDeDomaineWidgetType>;
};

export const NomsDeDomaineList: React.FunctionComponent<NomsDeDomaineListProps> = function (
    props: NomsDeDomaineListProps,
) {
    const { items } = props;
    return (
        <Box>
            {items
                ? items.map((itemProps: NomsDeDomaineWidgetType, index) => (
                      <NomsDeDomaineWidget
                          key={`nomsDeDomaine-${itemProps.nomsDeDomaine.domaine}}`}
                          {...itemProps}
                          index={index}
                      />
                  ))
                : null}
        </Box>
    );
};
